import { ActionTypes } from "./types";

let INITIAL_STATE = {
  loading: false,
  error: null,
  success: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.OTP_LOADING:
      return { ...state, loading: true };
    case ActionTypes.OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };

    case ActionTypes.OTP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
